import React from "react";
import { useTranslation } from "react-i18next";
import { Table, TableProps } from "@otp/ui";

import { User } from "src/graphql/generated/graphql";
import { getTableConfig } from "./config";

type OtpTableProps = Omit<TableProps, "columns"> & {
  className?: string;
  data: Partial<User>[];
};

export const OtpTable = ({ className, data, ...props }: OtpTableProps) => {
  const { t } = useTranslation();
  const tableConfig = getTableConfig(data || [], { t });

  return (
    <div className={className}>
      <Table {...props} data={data} columns={tableConfig} />
    </div>
  );
};
